import { Platform } from 'react-native';
import { navigationRef } from '@navigation/rootNavigation';
import { getActiveRouteCrumbs } from '@navigation/utils/getActiveRouteName';
import { resetToDashboardStackRoot } from '@navigation/utils/resetToDashboardStackRoot';

/**
 * Dashboard tabs that open a specific record. After a company switch those
 * should reopen on the list, not the previous company's record.
 */
const AREA_ROOT_ALIAS: Record<string, string> = {
  IntegrationDetail: 'Integrations',
};

export function dashboardAreaFromRouteNames(names: string[]): string | null {
  const dashboardIndex = names.indexOf('Dashboard');
  if (dashboardIndex < 0) return null;
  const area = names[dashboardIndex + 1];
  if (!area) return null;
  return AREA_ROOT_ALIAS[area] ?? area;
}

/** Active Dashboard tab (Knowledge, Data, …), ignoring the open document. */
export function getActiveDashboardArea(): string | null {
  if (!navigationRef.isReady()) return null;
  const names = getActiveRouteCrumbs(navigationRef.getRootState()).map((crumb) => crumb.name);
  return dashboardAreaFromRouteNames(names);
}

/**
 * Leave the current document and reload the session, then return to the root
 * of the Dashboard area the user was in (Knowledge menu, Data menu, …).
 * Web root screen is `Loading`; native LoginStack uses `LoadingScreen`.
 */
export function navigateAfterCompanyContextSwitch(): void {
  const returnArea = getActiveDashboardArea();
  const screen = Platform.OS === 'web' ? 'Loading' : 'LoadingScreen';

  if (!navigationRef.isReady()) {
    if (returnArea) resetToDashboardStackRoot(returnArea);
    return;
  }

  const routeNames = navigationRef.getRootState()?.routeNames ?? [];
  if (routeNames.includes(screen)) {
    navigationRef.navigate(screen as never, (returnArea ? { returnArea } : undefined) as never);
    return;
  }

  if (returnArea) resetToDashboardStackRoot(returnArea);
}
